import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL

export const requestVehicleApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page+1 : 1
  let url = `${env}${API_ENDPOINT.AssignVehicle.requestVehicleApi + '?type=' + data?.type+"&page="+page+"&pageSize="+data?.pageSize}`
  const res = await requestInstance.get(
    url
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const listAssignedVehicleApi = async (id) => {
  let url = `${env}${API_ENDPOINT.AssignVehicle.listAssignedVehicleApi}`
  const res = await requestInstance.get(
    url
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const assignVehicleApi = async (id) => {
  let url = `${env}${API_ENDPOINT.AssignVehicle.assignVehicleApi}`
  const res = await requestInstance.get(
    url
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const updateAssignVehicleApi = async (data) => {
  const res = await requestInstance.put(
    `${env}${API_ENDPOINT.AssignVehicle.assignVehicleApi}`,
    data
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
export const updateAssignDriverApi = async (data) => {
  const res = await requestInstance.put(
    `${env}${API_ENDPOINT.AssignVehicle.assignDriverApi}`,
    data
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}

export const  assignDriverApi = async(data) => {
  let url = ''
  const page = data?.page === 0 || data?.page ? data?.page+1 : 1
  if(data?.tripId){
    url = `${env}${API_ENDPOINT.Trip.assignDriverApi+'?tripId='+data?.tripId+'&isB2B=true'+"&page="+page+"&pageSize="+data.pageSize+"&search="+(data?.search ? data?.search : "")}`
  }else{
    url = `${env}${API_ENDPOINT.Trip.assignDriverApi+'?vehicleId='+data?.vehicleId+'&isB2B=true'+"&page="+page+"&pageSize="+data.pageSize+"&search="+(data?.search ? data?.search : "")}`
  }
  const res = await requestInstance.get(
    url
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const updateAssignSubVendorApi = async (data) => {
  const res = await requestInstance.put(
    `${env}${API_ENDPOINT.AssignVehicle.assignSubVendorApi}`,
    data
  )
    .catch((err) => err.response)
  return setCurrentUser(res)
}
